module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"segmentationByPages":"Segmentation by pages"},"fr":{"segmentationByPages":"Segmentation par pages"},"de":{"segmentationByPages":"Segmentierung nach Seiten"}}')
  delete Component.options._Ctor
}
